import { RefObject } from "react";
import { Spinner } from "react-bootstrap";
import { PrimaryButton } from "components/Button/style";

interface ImportarPlanilhaProps {
  loading: boolean;
  progresso: { atual: number; total: number } | null;
  fileInputRef: RefObject<HTMLInputElement>;
  onBaixarModelo: () => void;
  onArquivo: (file: File) => void;
}

export function ImportarPlanilha({ loading, progresso, fileInputRef, onBaixarModelo, onArquivo }: ImportarPlanilhaProps) {
  if (loading) {
    return (
      <div className="text-center py-4">
        <Spinner animation="border" variant="primary" style={{ width: "2.5rem", height: "2.5rem" }} />
        {progresso ? (
          <>
            <p className="mt-3 fw-bold">{progresso.atual} / {progresso.total} placas</p>
            <div style={{ maxWidth: 300, margin: "0 auto" }}>
              <div className="progress">
                <div
                  className="progress-bar"
                  style={{ width: `${(progresso.atual / progresso.total) * 100}%` }}
                />
              </div>
            </div>
            <p className="mt-2 text-muted" style={{ fontSize: "0.85rem" }}>
              Validando tags existentes e importando...
            </p>
          </>
        ) : (
          <p className="mt-2 text-muted">Processando planilha...</p>
        )}
      </div>
    );
  }

  return (
    <div className="text-center py-4">
      <p className="mb-1" style={{ fontWeight: 600 }}>
        Selecione uma planilha (.xlsx) com as placas na coluna "Placa":
      </p>
      <p className="text-muted mb-4" style={{ fontSize: "0.85rem" }}>
        Será validado se cada placa possui processo no sistema antes de cadastrar.
      </p>
      <div style={{ maxWidth: 400, margin: "0 auto", display: "flex", flexDirection: "column", gap: 10, alignItems: "center" }}>
        <PrimaryButton outline variante="primary" onClick={onBaixarModelo}>
          Baixar modelo (.xlsx)
        </PrimaryButton>
        <input
          ref={fileInputRef}
          type="file"
          accept=".xlsx,.xls,.csv"
          className="form-control"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) { onArquivo(file); }
          }}
        />
      </div>
    </div>
  );
}
